import React from 'react';
import { Callout } from "src/components";
import { SessionFieldsFragment } from 'src/data';
import { $t, showsLawfulPresenceNote } from 'src/utils';

export function PlanCallouts({ loading, session, limitedPlanData }: { loading: boolean, partner?: string; session?: SessionFieldsFragment; showOffExchange?: boolean; limitedPlanData?: boolean }) {

  const callouts = [
    {
      id: 'limited-plan-data',
      bg: "var(--c-orange-1)",
      imageSrc: "/iconic/shield-warning.svg",
      title: "More plans to come, check back soon",
      text: "Not all carriers have released plans in your state",
      visible: limitedPlanData,
    },
    {
      id: 'lawful-presence',
      bg: "var(--c-orange-1)",
      imageSrc: "/iconic/information.svg",
      title: $t({
        id: 'health-eligibility.lawful-presence-note-title',
        defaultMessage: 'Note',
      }),
      text: $t({
        id: 'health-eligibility.lawful-presence-note',
        defaultMessage:
          'These results are only an estimate. Federal law (H.R.1) has changed eligibility rules for many lawfully present non-citizens — including limits on subsidies and Medicaid access. You must complete an application to receive an official eligibility determination.',
      }),
      visible: showsLawfulPresenceNote({ state: session?.state, members: session?.deps }),
    },
  ].filter(item => item.visible);


  if (loading || callouts.length === 0) {
    return null;
  }

  return (
    <div style={{ marginTop: 24 }}>
      {callouts.map(callout => (
        <Callout
          key={callout.id}
          smallText
          imageSrc={callout.imageSrc}
          bg={callout.bg}
          title={callout.title}
          text={callout.text}
        />
      ))}
    </div>
  );
}
